import { render } from "./TeacherMgmt.vue?vue&type=template&id=cfdbdc78"
import script from "./TeacherMgmt.vue?vue&type=script&lang=js"
export * from "./TeacherMgmt.vue?vue&type=script&lang=js"

import "./TeacherMgmt.vue?vue&type=style&index=0&id=cfdbdc78&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__